import React from 'react'
import Image from 'next/image'

import { Layout, Section } from '@/components/layout'
import { Text } from '@/components/common'
import secureInfo from '@/assets/neat-competitor/secure-info.png'

import styles from './InformationSecure.module.scss'

export default function InformationSecure() {
  return (
    <Layout.Content>
      <Section>
        <div className={styles.infoSecure}>
          <Image alt="" src={secureInfo} />
          <div>
            <Text.H2 className="c-brand">Keeping Your Information Secure is Our Top Priority</Text.H2>
            <p>20 years of security and data protection equates to centuries in the tech world. With that
              experience comes a deep knowledge of data security. Because we use the highest standard of
              bank-level encryption, your data is kept secure from any breaches.
            </p>
            <ul>
              <li>We will never sell customer information to third parties</li>
              <li>We monitor our infrastructure 24/7, 365</li>
              <li>We utilize leading, compliant data centers</li>
              <li>We perform numerous external audits and assessments</li>
              <li>We use bank-level encryption</li>
            </ul>
          </div>
        </div>
      </Section>
    </Layout.Content>
  )
}
